import router from '@/router'
import { createGtm } from '@gtm-support/vue-gtm'

export default {
  /** @param {import('vue').App} app */
  install (app) {
    const gtmPlugin = createGtm({
      id: import.meta.env.VUE_APP_GTM_ID || 'GTM-DUMMYID', // The plugins requires to be passed a well formatted ID (even when disabled)
      // Start disabled by default. Will be enabled after confirming the license is not on-prem.
      // This prevents analytics from being sent before we can verify the license type.
      enabled: false,
      vueRouter: router, // Passing the router enables automatic pageview tracking.
    })

    app.use(gtmPlugin)
  },
}
